import Sidennav from './sidenavbar';
import Topnavbar from './topnavbar';
import DashboardElement from './dashboardElement';

function Dashboard() {
    return[
        <Sidennav />,
        <Topnavbar />,
        <DashboardElement />
    ];
    
}

export default Dashboard;